import { DataSyncEmpty } from './sections/DataSyncEmpty';
import { DataSyncIndexHeader } from './sections/DataSyncIndexHeader';
import { DataSyncErrorState, DataSyncSuccessState } from '../common/DataSyncStates';
import { CreateDestinationModal } from '../../modals';
import { useGetDestinations, usePrequelContext } from '../../../contexts';
import { ExpandModes } from 'utils/contexts/expansion';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { fetchDestinationsResponse } from '../../../ducks/actions';
import { useDestinationTable } from '../../../contexts/DestinationTableContext';
import { transformDestinationData } from '../../../utils';
import { IndexPageContainer } from './DataSyncIndexPage.styles';
import { DestinationTable, DestinationPagination } from './sections/table';

export const DataSyncIndexPage = () => {
  const { modalExpandMode } = usePrequelContext();
  const getDestinations = useGetDestinations();
  const dispatch = useDispatch();
  const isModalOpen = modalExpandMode === ExpandModes.expand;

  // Use context state instead of local state
  const { rawDestinations, loading, error, refetch } = useDestinationTable();

  useEffect(() => {
    if (!rawDestinations.length) {
      const fetchDestinations = async () => {
        const fetchedDestinations = await getDestinations();

        const mockedDestination = Array(4).fill(fetchedDestinations).flat();

        // Transform raw API response to clean Destination objects
        const transformedDestinations = mockedDestination.map(transformDestinationData);

        if (transformedDestinations.length) {
          dispatch(fetchDestinationsResponse(transformedDestinations));
        }
      };

      fetchDestinations();
    }
  }, [getDestinations, rawDestinations, dispatch]);

  const renderContent = () => {
    if (error && !loading) {
      return <DataSyncErrorState onRetry={refetch} />;
    }

    if (rawDestinations.length === 0 && !loading) {
      return (
        <DataSyncSuccessState>
          <DataSyncEmpty />
        </DataSyncSuccessState>
      );
    }

    return (
      <DataSyncSuccessState>
        <DestinationTable />
        <DestinationPagination />
      </DataSyncSuccessState>
    );
  };

  return (
    <IndexPageContainer>
      <DataSyncIndexHeader />
      {renderContent()}
      {isModalOpen && <CreateDestinationModal />}
    </IndexPageContainer>
  );
};
